


















import Vue from 'vue';
import {faFacebookF, faTwitter} from '@fortawesome/free-brands-svg-icons';

import {eventBus} from '@/event-bus';


export default Vue.extend({
  name: 'social-sharing',

  data () {
    return {
      eventBus,
      showSocialSharing: false,
      timeout: 0,
      shareIcons: [
        {
          network: 'Facebook',
          icon: faFacebookF,
          text: 'Share on Facebook',
          title: 'Sharing title...',
          description: 'Description...',
        },
        {
          network: 'Twitter',
          icon: faTwitter,
          text: 'Share on Twitter',
          title: 'Sharing title...',
          description: 'Description...',
        },
      ],
    };
  },

  methods: {
    hideSocialSharing () {
      const container = document.querySelector('.social-sharing-container');

      container!.addEventListener('mouseleave', () => {
        this.timeout = window.setTimeout(() => {
          this.showSocialSharing = false;
        }, 5000);
      });
    },
  },

  computed: {
    fullSiteURL (): string {
      return window.location.href;
    },
  },

  mounted () {
    this.hideSocialSharing();
  },

  created () {
    this.eventBus.$on('open-social-sharing', (isOpen: boolean) => {
      this.showSocialSharing = isOpen;
    });
  },

  beforeDestroy () {
    clearTimeout(this.timeout);
  },
});
